import findGameInTheList from '../entities/findGameInTheList';
import changeSwipeGameIcon from '../entities/changeSwipeGameIcon';
import getElementSelectors from '../shares/lib/getElementSelectors';
import { setLocalStore } from '../shares/lib/localStore';
import { createIframe } from '../shares/ui/createIframe';
import { LocalStoreKeys } from '../shares/enums/localStoreKeys';
import playGame from './playGames';
import eventEmitters from '../shares/lib/eventEmitters';
import eventType from '../shares/enums/eventType';
import { SelectedGame } from '../shares/types/SwipeSDKConfigType';

const selectGameFromDropdown = (): void => {
  const {
    dropdownMenu,
    dropdown,
    dropdownToggle,
    dropDownItem,
    swipe_control,
    dropDownOverlay,
    swipeErrorMsg,
  } = getElementSelectors();

  if (dropdownMenu) {
    dropdownMenu.addEventListener('click', async (e: Event) => {
      const target = e.target as HTMLElement;
      if (!target?.getAttribute('data-game-id')) return;

      dropDownItem.forEach((item: HTMLElement) => {
        item.classList.remove('hidden');
      });

      target.classList.add('hidden');
      swipeErrorMsg!.style.display = 'none';

      const gameId: string = target.getAttribute('data-game-id')!;
      const dropdownTogglePrevGameId: string =
        dropdownToggle!.getAttribute('data-game-id')!;

      if (!gameId) return;

      const foundGame = findGameInTheList(gameId);

      const currentGameselected: SelectedGame = {
        previousGameId: dropdownTogglePrevGameId,
        currentGameId: gameId,
      };

      setLocalStore(LocalStoreKeys.SELECTED_GAME, currentGameselected);

      changeSwipeGameIcon(currentGameselected);

      dropdown?.classList.toggle('open');
      dropDownOverlay!.classList.toggle('open');

      const gameLaunchUrl = foundGame ? await playGame() : null;
      if (gameLaunchUrl) {
        createIframe(gameLaunchUrl);
      }

      eventEmitters(eventType.SWIPE_GAMECHANGE);
      e.stopPropagation();
    });
  }

  if (dropDownOverlay) {
    dropDownOverlay.addEventListener('click', () => {
      dropdown?.classList.toggle('open');
      dropDownOverlay.classList.toggle('open');
    });
  }

  if (swipe_control) {
    window.addEventListener('resize', () => {
      const swipeYPos = sessionStorage.getItem('swipeYPos');
      if (swipeYPos) {
        swipe_control.style.top = `${Number(swipeYPos)}%`;
      }

      const vh = window.innerHeight - 54 * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  }
};

export default selectGameFromDropdown;
